import React, {useEffect, useMemo} from 'react';
import {Helmet} from "react-helmet";
import {
    Link, useLocation,
} from "react-router-dom";

import {connect} from 'react-redux';

const defaultSupportedCountries = ["uk","mt","ie"]
const getCountryNameLang = (country) => {
    switch (country){
        case 'mt':
            return ["Malta","en-MT"];
        case 'uk':
            return ["United Kingdom","en-GB"];
        case 'ie':
            return ["Ireland","en-IE"];
        default:
            return [null,null];
    }
}

function SeoHeaders({
    // country,
    title,
    description,
    supportedCountries
}) {

    const location = useLocation()
    const path = location.pathname

    const countryCode = path.split('/')[1]
    const country = ['uk', 'mt', 'ie'].includes(countryCode) ? countryCode: null

    const [countryName,lang] = useMemo(() => {
        return getCountryNameLang(country)
    }, [country]);

    const link = `https://www.buddy.hr${path}`

  return (
      <Helmet>
          <title>{title.replace('[country]',countryName)}</title>
          <meta name="description" content={description.replace('[country]',countryName)} />
          <link rel="canonical" href={link} />
          <html lang={lang} amp />
          {
              (supportedCountries ?? defaultSupportedCountries)?.map(c => {

                  const localLink = country ? link.replace(`buddy.hr/${country}`,`buddy.hr/${c}`) : link.replace(`buddy.hr`,`buddy.hr/${c}`)
                  const [name, hrefLang] = getCountryNameLang(c)

                  return <link rel="alternate" href={localLink} hrefLang={hrefLang} key={hrefLang}/>
              })
          }
      </Helmet>

  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SeoHeaders)
